import { __assign } from "tslib";
import React from 'react';
import { ThemeContext } from '../models/ThemeProvider';
import determineTheme from '../utils/determineTheme';
import getComponentName from '../utils/getComponentName';
import hoist from '../utils/hoist';
export default function withTheme(Component) {
    var WithTheme = React.forwardRef(function (props, ref) {
        var theme = React.useContext(ThemeContext);
        var themeProp = determineTheme(props, theme, Component.defaultProps);
        if (process.env.NODE_ENV !== 'production' && themeProp === undefined) {
            console.warn("[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class \"".concat(getComponentName(Component), "\""));
        }
        return React.createElement(Component, __assign({}, props, { theme: themeProp, ref: ref }));
    });
    if (process.env.NODE_ENV !== 'production') {
        WithTheme.displayName = "WithTheme(".concat(getComponentName(Component), ")");
    }
    return hoist(WithTheme, Component);
}
//# sourceMappingURL=withTheme.js.map